import React from 'react';
import ReactDOM from 'react-dom';
import './global.scss';
import App from './App';
import { Provider } from 'react-redux'
import {createStore} from 'redux'
import reducer from './reducer/reducer'

const store = createStore(reducer)

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
